var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("雇主险管理-详情")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-40px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Return
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "white",
      "margin": "75px 40px 0 40px",
      "overflow-x": "hidden"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "300px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "80px",
      "width": "80%"
    },
    attrs: {
      "label": "保单名称：",
      "prop": "name"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.ruleForm.insurance_name) + "\n\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "80px",
      "width": "80%"
    },
    attrs: {
      "label": "投保账户：",
      "prop": "name"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.ruleForm.insure_account) + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "承保公司：",
      "prop": "region"
    }
  }, [_vm._v(_vm._s(_vm.ruleForm.company_id))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "生效时间："
    }
  }, [_vm._v(_vm._s(_vm.ruleForm.start_date) + " ~\n\t\t\t\t\t\t\t" + _vm._s(_vm.ruleForm.end_date) + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "单价：",
      "prop": "name"
    }
  }, [_vm._v(_vm._s(_vm.ruleForm.unit_price) + "\n\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "保费：",
      "prop": "name"
    }
  }, [_vm._v(_vm._s(_vm.ruleForm.premium) + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "保额：",
      "prop": "name"
    }
  }, [_vm._v(_vm._s(_vm.ruleForm.insured_amount) + "\n\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "免赔额、比例：",
      "prop": "name"
    }
  }, [_vm._v(_vm._s(_vm.ruleForm.proportion) + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "承保公司联系人：",
      "prop": "name"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.ruleForm.company_contacts) + "\n\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "承保公司联系电话：",
      "prop": "name"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.ruleForm.company_telephone) + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "保单扫描件：",
      "prop": "name"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.ruleForm.insurance_url
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "其他附件：",
      "prop": "name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注：",
      "prop": "name"
    }
  }, [_vm._v(_vm._s(_vm.ruleForm.remarks))])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "适用范围：",
      "prop": "region"
    }
  }, _vm._l((_vm.rangeListIndex), function(item, index) {
    return _c('el-row', {
      key: index,
      staticStyle: {
        "margin-bottom": "20px"
      }
    }, [_c('el-form', {
      ref: "rangeRuleForm",
      refInFor: true,
      attrs: {
        "model": _vm.ruleForm.rangeList[index],
        "rules": _vm.rangeRules
      }
    }, [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$globals.group_name + '>' + _vm.ruleForm.rangeList[index].range) + "\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.ruleForm.rangeList[index].post_name) + "\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.ruleForm.rangeList[index].dataName != null && _vm.ruleForm.rangeList[index].dataName != '' ? _vm.ruleForm.rangeList[index].dataName : '不限') + "\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.ruleForm.rangeList[index].gender != null && _vm.ruleForm.rangeList[index].gender != '' ? (_vm.ruleForm.rangeList[index].gender == '1' ? '男' : '女') : '不限') + "\n\t\t\t\t\t\t\t\t\t")])], 1)], 1)
  }), 1)], 1)], 1)], 1)], 1)], 1)])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a4de3bb","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bxgl/GzxGl/Gzxgl_edit.vue
// module id = null
// module chunks = 